module.exports = __webpack_public_path__ + "_/public/unpin.png?4c32e75e";


//////////////////
// WEBPACK FOOTER
// ../public/unpin.png
// module id = 615
// module chunks = 0